<template>
  <div class="flex flex-column" style="width: 100%">
    <div class="flex align-items-center justify-content-center">
      <div class="card" style="width: 100%">
        <div class="field grid justify-content-center" style="align-items: baseline">
          <label class="col-fixed">E-Mail-Adresse:</label>
          <InputText
            id="userMailAddress"
            v-model="settings.userMailAddress"
            @change="userMailAddressChanged"
            style="width: 100%; min-width: 250px; max-width: 350px"
          />
        </div>
        <div class="field grid justify-content-center" style="align-items: baseline">
          <label for="userMailAddress" class="col-fixed"
            >E-Mail bei neuen Nachrichten:</label
          >
          <SelectButton
            :options="[
              {
                label: 'Ja',
                value: 'true',
                disabled: !(
                  settings.userMailAddress && settings.userMailAddress.length > 0
                ),
              },
              {
                label: 'Nein',
                value: 'false',
                disabled: false,
              },
            ]"
            optionLabel="label"
            optionValue="value"
            optionDisabled="disabled"
            v-model="settings.mailOnNewConversation"
            @change="mailOnNewConversationChanged"
          />
        </div>
        <div
          class="text-color-secondary"
          style="font-size: 0.85em; max-width: 700px; margin: 0 auto"
        >
          Neue Nachrichten an dich sammelt das Programm und schickt sie frühestens 30
          Minuten nach Eingang gebündelt an die oben hinterlegte Adresse; kommen viele
          hintereinander, wird der Abstand zwischen den E-Mails größer — 2, dann 6, dann
          24 Stunden. Über jede Nachricht wirst du genau einmal informiert, auch wenn du
          sie nicht liest. Gemeldet wird nur, was nach dem Einschalten eingeht.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useSettingsService } from "../../services/SettingsService/UseSettingsService";
import InputText from "primevue/inputtext";
import SelectButton from "primevue/selectbutton";

export default {
  name: "MailSettings",
  components: {
    InputText,
    SelectButton,
  },
  created() {
    this.settingService.getSettings().then((settings) => this.updateSettings(settings));
  },
  data() {
    return {
      settingService: useSettingsService(),
      settings: {},
    };
  },
  methods: {
    updateSettings(settings) {
      this.settings = settings;
      if (!this.settings.mailOnNewConversation) {
        this.settings.mailOnNewConversation = "false";
      }
    },
    userMailAddressChanged() {
      this.settingService
        .saveSetting("userMailAddress", '"' + this.settings.userMailAddress + '"')
        .then((settings) => this.updateSettings(settings));
    },
    mailOnNewConversationChanged() {
      this.settingService
        .saveSetting("mailOnNewConversation", this.settings.mailOnNewConversation)
        .then((settings) => this.updateSettings(settings));
    },
  },
};
</script>

<style lang="css" scoped></style>
